import React from "react";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import IconEmail from "./icon-email.svg";
import { Container, Summary, Title, TitleAndSummaryContainer } from "./styles";
export const SummaryDisplay = () => {
  var _newsletterItemForDis;
  const {
    newsletterItemForDisplay
  } = useNewsletterContext();
  return /*#__PURE__*/React.createElement(Container, {
    "data-qa": "summary-display"
  }, /*#__PURE__*/React.createElement(TitleAndSummaryContainer, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(IconEmail, null), "NEWSLETTER"), /*#__PURE__*/React.createElement(Summary, null, newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 || (_newsletterItemForDis = newsletterItemForDisplay.summary) === null || _newsletterItemForDis === void 0 ? void 0 : _newsletterItemForDis.text)));
};
SummaryDisplay.displayName = "SummaryDisplay";